import { FC } from 'react';
import axios from 'axios';
import { saveAs } from 'file-saver';

// redux
import { setError } from 'redux/error-service/action';

// components
import ButtonDownload from 'shared/components/Buttons/ButtonDownload';
import SwitchIos from 'shared/components/SwitchIos';

// types
import { SearchOrganizationByAdminRequest } from '@joc/api-gateway';

// styles
import styles from './Actions.module.scss';

type ActionsProps = {
	isAllTime: boolean;
	onToggleIsAllTime: () => void;
	isAllowExport: boolean;
	searchBody: SearchOrganizationByAdminRequest;
};

const Actions: FC<ActionsProps> = ({ isAllTime, onToggleIsAllTime, isAllowExport = false, searchBody }) => {
	const buttonDownloadClickHandler = async () => {
		try {
			const accessToken = localStorage.getItem('accessToken');
			if (!accessToken) throw new Error('Sorry, we can`t find your access token');

			const opportunitiesResponse = await axios(`${process.env.REACT_APP_JOC_API}/organisations/exportByAdmin`, {
				method: 'POST',
				responseType: 'blob',
				headers: {
					Authorization: `Bearer ${accessToken}`,
				},
				data: searchBody,
			});

			saveAs(opportunitiesResponse.data, `organizations_list`);
		} catch (error: any) {
			setError(error?.response?.message || error.message, error.code);
		}
	};
	return (
		<div className={styles.wrapper}>
			<div className={styles.toggle}>
				<span
					className={
						isAllTime ? `${styles.toggle__label} ${styles.toggle__label_active}` : styles.toggle__label
					}
					onClick={isAllTime ? undefined : onToggleIsAllTime}
				>
					All time
				</span>
				<SwitchIos isChecked={!isAllTime} clickHandler={onToggleIsAllTime} />
				<span
					className={
						!isAllTime ? `${styles.toggle__label} ${styles.toggle__label_active}` : styles.toggle__label
					}
					onClick={!isAllTime ? undefined : onToggleIsAllTime}
				>
					Current year
				</span>
			</div>

			<ButtonDownload clickHandler={buttonDownloadClickHandler} disabled={!isAllowExport} />
		</div>
	);
};

export default Actions;
